import { apiAuthenticatedInstance } from '@/services/API';

export async function scanQrCode({ qrcode }): Promise<any> {
  return (await apiAuthenticatedInstance().post(`/api/actions/scan`, { qrcode })).data;
}
